import TurboFrameSearchController from "./shared/turbo_frame_search.js";

export default class extends TurboFrameSearchController {
  get focusAttributes() {
    return {
      pending: "data-easy-workflow-catalogue-search-pending",
      caretStart: "data-easy-workflow-catalogue-search-caret-start",
      caretEnd: "data-easy-workflow-catalogue-search-caret-end",
    };
  }
}
